import { render, staticRenderFns } from "./goods_coupon.vue?vue&type=template&id=4fc0b482&scoped=true"
import script from "./goods_coupon.vue?vue&type=script&lang=js"
export * from "./goods_coupon.vue?vue&type=script&lang=js"
import style0 from "./goods_coupon.vue?vue&type=style&index=0&id=4fc0b482&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc0b482",
  null
  
)

export default component.exports